<div class="hotspot-popup">
  <button class="dialog-close-button" [mat-dialog-close]>
    <span class="material-icons"> close </span>
  </button>
  <div [innerHTML]="html"></div>
</div>
